// ------------------- LOCATIONS -------------------

import { API_ROUTES } from "@/auth/api/config.ts";
import { AxiosResponse } from "axios";
import { ApiResponse } from "@/shared/types/api.ts";
import axiosClient from "@/shared/lib/axios/axios.ts";

// ------------------- ORGANIZATIONS -------------------

export interface IGetOrganizationsInput {
  page?: number;
}

export interface IGetOrganizationsResponse {
  id: number;
  name: string;
}

export const getOrganizations = async (page: number = 1) => {
  return axiosClient
    .get<IGetOrganizationsInput, AxiosResponse<ApiResponse<IGetOrganizationsResponse[]>>>(
      `${API_ROUTES.USER_ORGANIZATION}?page=${page}`
    )
    .then((res) => res.data);
};

export interface IGetOrganizationByIdInput {
  id: number;
}

export interface IGetOrganizationByIdResponse {
  id: number;
  name: string;
}

export const getOrganizationById = async (id: number) => {
  return axiosClient
    .get<IGetOrganizationByIdInput, AxiosResponse<ApiResponse<IGetOrganizationByIdResponse>>>(
      `${API_ROUTES.USER_ORGANIZATION}${id}/`
    )
    .then((res) => res.data);
};

// ------------------- USER ME -------------------

export interface IGetCurrentUserInput {}

export interface IGetCurrentUserResponse {
  id: number;
  username: string;
  email: string;
}

export const getCurrentUser = async () => {
  return axiosClient
    .get<IGetCurrentUserInput, AxiosResponse<ApiResponse<IGetCurrentUserResponse>>>(
      API_ROUTES.USER_ME
    )
    .then((res) => res.data);
};